"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexMeasure = void 0;
// Index types
var IndexMeasure;
(function (IndexMeasure) {
    IndexMeasure["COSINE_DISTANCE"] = "cosine_distance";
    IndexMeasure["L2_DISTANCE"] = "l2_distance";
    IndexMeasure["MAX_INNER_PRODUCT"] = "max_inner_product";
})(IndexMeasure || (exports.IndexMeasure = IndexMeasure = {}));
//# sourceMappingURL=types.js.map